import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Stav", "caption": "Stav"},
    {"label": "Uzavrety", "caption": "Uzavretý"},
    {"label": "Farba"}
]

function LoanStates(props) {
    const initialFilters = []
    const baseUrl = '/loan/loans_states'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Stav': `/loan_states/loan_state/${entry.id}`
        }))
    }

    function colorize() {
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0,1)
        new_rows.forEach(row => {
            const cell = row.getElementsByTagName("td")[2]
            const color = cell.innerText
            cell.style.backgroundColor = color
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data])

    return (
        <ListViewCommon baseUrlFrontend={`/loan_states/loan_state`}
                        // filters={filters}
                        // filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}s
                        data={data}
                        delete_single={delete_single}
                        label={"Stavy zápožičiek"}
        />
    )
}

export default LoanStates
